var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setup-theme-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"setup-theme-promo"},[_c('img',{attrs:{"src":"https://admin.sales.bazis.kz/media/bazis-logo_2023.svg","alt":""}}),_c('h2',[_vm._v("Здесь скоро будет сайт")]),_c('h2',[_vm._v("Жақында сайт болады")])])])])
}]

export { render, staticRenderFns }